import { NDCService } from "./implementations/ndc.service.js";

export default defineNuxtPlugin((nuxtApp) => {
  const ndc = new NDCService(nuxtApp.$axios, nuxtApp.$config.public.sgApiUrl);

  return {
    provide: {
      ndc: ndc,
    },
  };
});
